/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseOfString } from '../models/api-response-of-string';
import { CarefinityRoles } from '../models/carefinity-roles';
import { DataPageOfManageRoles } from '../models/data-page-of-manage-roles';
import { rolesCreateRoles } from '../fn/roles/roles-create-roles';
import { RolesCreateRoles$Params } from '../fn/roles/roles-create-roles';
import { rolesDelete } from '../fn/roles/roles-delete';
import { RolesDelete$Params } from '../fn/roles/roles-delete';
import { rolesEditRoles } from '../fn/roles/roles-edit-roles';
import { RolesEditRoles$Params } from '../fn/roles/roles-edit-roles';
import { rolesGetCarefinityRoles } from '../fn/roles/roles-get-carefinity-roles';
import { RolesGetCarefinityRoles$Params } from '../fn/roles/roles-get-carefinity-roles';
import { rolesList } from '../fn/roles/roles-list';
import { RolesList$Params } from '../fn/roles/roles-list';

@Injectable({ providedIn: 'root' })
export class RolesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `rolesList()` */
  static readonly RolesListPath = '/roles/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesList$Response(params?: RolesList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfManageRoles>> {
    return rolesList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rolesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesList(params?: RolesList$Params, context?: HttpContext): Observable<DataPageOfManageRoles> {
    return this.rolesList$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfManageRoles>): DataPageOfManageRoles => r.body)
    );
  }

  /** Path part for operation `rolesGetCarefinityRoles()` */
  static readonly RolesGetCarefinityRolesPath = '/roles/getCarefinityroles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesGetCarefinityRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesGetCarefinityRoles$Response(params?: RolesGetCarefinityRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<CarefinityRoles>> {
    return rolesGetCarefinityRoles(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rolesGetCarefinityRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesGetCarefinityRoles(params?: RolesGetCarefinityRoles$Params, context?: HttpContext): Observable<CarefinityRoles> {
    return this.rolesGetCarefinityRoles$Response(params, context).pipe(
      map((r: StrictHttpResponse<CarefinityRoles>): CarefinityRoles => r.body)
    );
  }

  /** Path part for operation `rolesCreateRoles()` */
  static readonly RolesCreateRolesPath = '/roles/createCarefinityroles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesCreateRoles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesCreateRoles$Response(params: RolesCreateRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return rolesCreateRoles(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rolesCreateRoles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesCreateRoles(params: RolesCreateRoles$Params, context?: HttpContext): Observable<Blob> {
    return this.rolesCreateRoles$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `rolesEditRoles()` */
  static readonly RolesEditRolesPath = '/roles/updateCarefinityroles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesEditRoles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesEditRoles$Response(params: RolesEditRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return rolesEditRoles(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rolesEditRoles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesEditRoles(params: RolesEditRoles$Params, context?: HttpContext): Observable<Blob> {
    return this.rolesEditRoles$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `rolesDelete()` */
  static readonly RolesDeletePath = '/api/Roles/{Roleid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesDelete$Response(params: RolesDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOfString>> {
    return rolesDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rolesDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesDelete(params: RolesDelete$Params, context?: HttpContext): Observable<ApiResponseOfString> {
    return this.rolesDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseOfString>): ApiResponseOfString => r.body)
    );
  }

}
